import { getCondoTechsDetails } from '@/services';
export default {
    name: 'CondoTechsDetails',
    data: () => ({
        details: {
            title: '',
            subtitle: '',
            logo: '',
            description: '',
            banner: ''
        }
    }),
    async created() {
        await this.getCondoTechsDetails();
    },
    methods: {
        async getCondoTechsDetails() {
            try {
                const details = await getCondoTechsDetails(this.$route.params.id);
                this.details = details;
            } catch (error) {
                console.error(error);
            }
        },
        contactUs(partner) {
            if (this.$route.name === 'CondoTechsEnterpriseDetails') {
                this.$router.push({ name: 'CondoTechsEnterpriseContactUs', params: { id: partner } });
            } else {
                this.$router.push({ name: 'CondoTechsContactUs', params: { id: partner } });
            }
        }
    }
};
